import Button from '@algbra/ui/components/Button/Button'
import FreeText from '@algbra/ui/components/FreeText/FreeText'
import { Column, Container, Row } from '@algbra/ui/components/Grid/Grid'
import Heading from '@algbra/ui/components/Heading/Heading'
import { VAlign } from '@algbra/ui/enums/align'
import { getIconByName, IconNameType } from '@algbra/ui/icons'
import { GatsbyResolvedAsset } from '@algbra/ui/types/image'
import classNames from 'classnames'
import { GatsbyImage } from 'gatsby-plugin-image'
import React, { ReactNode } from 'react'
import { resolveAsImage } from '@algbra/ui/resolvers'
import styles from './SplitBox.module.scss'
import Permalink from '@algbra/ui/components/Permalink/Permalink'
import Icon from '@algbra/ui/components/Icon/Icon'

export type ZoneSplitBoxProps = {
  __typename: 'StrapiGQL_ComponentZonesSplitBox'
  title: string
  description: ReactNode
  image?: GatsbyResolvedAsset
  color?: string
  buttonText?: string
  buttonLink?: string
  buttonTheme?: 'primary' | 'light' | 'tetriary'
  buttonTarget: '_self' | 'new'
  iconName: IconNameType
}
export default function ZoneSplitBox(props: ZoneSplitBoxProps) {
  const {
    color = 'gray',
    title,
    description,
    image,
    buttonText,
    buttonLink,
    buttonTheme,
    buttonTarget,
    iconName,
  } = props
  const itemImage = image && resolveAsImage(image)
  const textColor = color === 'dark' || color === 'black' ? 'white' : 'primary'

  const BoxDetailLink = props => {
    return (
      <Permalink className={styles.linkText} to={props.linkUrl}>
        <FreeText
          className={classNames(
            [styles.boxDetailLink, props.className],
            [styles[props.theme], props.theme]
          )}
          color={props.linkColor}
        >
          <div
            className={classNames(styles.icon, [
              styles[props.theme],
              props.theme,
            ])}
          >
            <Icon
              icon={getIconByName('arrow-right')}
              size={24}
              className={styles.arrow}
            />
          </div>
          <div className={styles.linkText}>{props.linkText}</div>
        </FreeText>
      </Permalink>
    )
  }

  return (
    <Container className={styles.container}>
      <section
        className={classNames(styles.splitBox, styles[`color__${color}`])}
      >
        <Row
          className={styles.stretchRow}
          vAlign={VAlign.STRETCH}
          gutter={false}
        >
          <Column className={classNames(styles.padded)}>
            <Heading type="lg" level={2} className={styles.title}>
              {title}
            </Heading>
            <div className={styles.children}>
              <FreeText type="md" color={textColor} innerHTML={description}>
                {description}
              </FreeText>
            </div>
            {props.buttonText && (
              <BoxDetailLink
                linkColor={textColor || 'black'}
                linkUrl={buttonLink}
                linkText={buttonText}
                theme={textColor}
              />
            )}
          </Column>
          <Column auto={true} className={styles.image}>
            {itemImage && (
              <GatsbyImage
                loading="lazy"
                image={itemImage}
                alt=""
                role="presentation"
              />
            )}
          </Column>
        </Row>
      </section>
    </Container>
  )
}
